import { render } from "./RegistrationPending.vue?vue&type=template&id=a40373b2&scoped=true"
import script from "./RegistrationPending.vue?vue&type=script&lang=js"
export * from "./RegistrationPending.vue?vue&type=script&lang=js"

import "./RegistrationPending.vue?vue&type=style&index=0&id=a40373b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a40373b2"]])

export default __exports__